<template>
    <!-- Choix du modèle d'une campagne email : modèles enregistrés (éditeur : url / remove), ou création d'un modèle.
         #emailTemplate (name="emailTemplate") est lu par l'envoi et l'aperçu de la page. -->
    <div id="emailTemplateWrapper" class="mk-template">
        <label class="catalogue-modal-label" for="emailTemplate">Modèle · requis</label>
        <div class="mk-template-row">
            <select class="catalogue-modal-select" id="emailTemplate" name="emailTemplate" v-model="value">
                <option value="0">Choisir un modèle</option>
                <option v-for="(template, id) in templates" :value="id" :key="id">{{ template }}</option>
            </select>
            <a v-if="value > 0" :href="url + '?template=' + value" class="mk-button">Modifier</a>
            <a v-if="value > 0" :href="remove + '?template=' + value" class="mk-button is-danger"
               onclick="return confirm('Supprimer ce modèle d’email ?')">Supprimer</a>
        </div>

        <div v-if="value == 0" class="mk-template-new">
            <span>Ou créer un modèle</span>
            <div class="mk-template-row">
                <input type="text" class="catalogue-modal-input" placeholder="Nom du nouveau modèle" v-model="name" aria-label="Nom du nouveau modèle" />
                <a :href="name.length ? url + '?name=' + encodeURIComponent(name) : null" class="mk-button" :class="{ 'is-disabled': name.length < 1 }"
                   :aria-disabled="name.length < 1">Créer dans l’éditeur</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value: 0,
            name: '',
        }
    },
    props: {
        templates: Object,
        url: String,
        remove: String,
    },
}
</script>
